// TODO: Implement an actual poge for faqs

import ContentPlacer from "../components/ContentPlacer";
import PageDefault from "../components/PageDefault";

const faqs = [
  {
    question: "What is this tool?",
    answer:
      "SummerEyes is an AI-powered productivity tool that produces condensed summaries of any body of text on the internet by identifying key points and rewriting for clarity. It is currently implemented as a Google Chrome extension.",
  },
  {
    question: "What problem are you solving?",
    answer:
      "Too much to read, too little time. We have an abundance of information we have to get through in a day, but are constrained by how much we can process. SummerEyes reduces the information burden and increases how much knowledge we can process in a day by removing unneccessary or non-critical points from news articles, emails, documents, textbooks, etc.",
  },
  {
    question: "How much does this cost?",
    answer:
      "Right now, SummerEyes is free to use, as part of our Beta testing period. We will be implementing a paid subscription model in the near future.",
  },
  {
    question: "Are there any limitations on what I can summarize?",
    answer:
      "As we are only offering access to our Free subscription at present, not all features will be made available. Summarizations of text greater than a few thousand words and summarization of PDFs are not available without a Premium subscription.",
  },
  {
    question: "How does it work?",
    answer: (
      <>
        We run the inputted text through a Natural Language Process model that
        understands, evaluates, and rewrites the body of text in a way that
        optimizes information density. We are constantly trialling different
        models to optimize our results, and try identify the best possible model
        for each topic & user group. We train our Summary Engine with the
        feedback provided by our users , improving our capabilities over time.
      </>
    ),
  },
  {
    question: "Can I use it for any language?",
    answer:
      "Unfortunately, right now SummerEyes is only supported for English text. Other languages provided mixed results.",
  },
  {
    question: "Can I use it in any web browser?",
    answer:
      "Unfortunately, right now SummerEyes is only available for Google Chrome & Brave on desktop. We are planning on rolling out additional versions for Safari and Firefox in the near-term.",
  },
  {
    question: "Where can I find more info on upcoming features & improvements?",
    answer: (
      <>
        <a
          href="/register"
          className="text-summer-blue-600 hover:text-summer-blue-400"
        >
          Register an account
        </a>{" "}
        with us, and you will receive an email to signup for our newsletter. Our
        newsletter provides updates on our updates & planned feature roadmap,
        and is the best way to stay informed as we push to develop this product
        further.
      </>
    ),
  },
  {
    question: "Why is my summary taking time to load?",
    answer:
      "The processing time varies considerably based on a few factors. First, the larger the body of text, the longer the development of the summary will take - much like humans. Second, our server resources are currently limited in the Beta activation phase, and may be under-resourced to resolve summaries if there are too many concurrent users. Third, our servers sometimes suffer from the cold start problem, and may take a bit of time to warmup before processing the summary.",
  },
  {
    question: "What is the cold start problem?",
    answer:
      'We run an on-demand server architecture. What this means is that we dynamically scale up our servers to handle the demand of users - i.e., when there is a lot of demand, we turn on many resources, and when demand drops we turn them off again. At certain times, we have to start a new resource to fulfil a request. In the same way that your computer needs time when you first press the power button, our servers need a bit of time to turn on from "cold" - giving a slight delay before we can process your summary.',
  },
];

export default function Faqs({ session }) {
  return (
    <>
      <PageDefault pageTitle="FAQs | SummerEyes">
        <ContentPlacer>
          <div className="bg-white">
            <div className="mx-auto max-w-7xl py-16 lg:py-20">
              <div className="lg:grid lg:grid-cols-3 lg:gap-8">
                <div className="text-left md:text-right">
                  <h2 className="text-6xl font-medium text-summer-light">
                    <span className="bg-gradient-to-tr from-summer-light-highlight to-summer-bright bg-clip-text text-transparent">
                      Frequently asked questions
                    </span>
                  </h2>
                  <p className="mt-4 text-lg text-gray-500">
                    Can’t find the answer you’re looking for? Reach out to our{" "}
                    <a
                      href="mailto:support@summereyes.ai"
                      className="hover:text-summer-blue-600 font-medium text-summer-bright"
                    >
                      customer support
                    </a>{" "}
                    team.
                  </p>
                </div>
                <div className="mt-12 lg:col-span-2 lg:mt-0">
                  <dl className="space-y-12">
                    {faqs.map((faq) => (
                      <div key={faq.question}>
                        <dt className="text-lg font-semibold leading-6 text-gray-900">
                          {faq.question}
                        </dt>
                        <dd className="mt-2 text-base text-gray-500">
                          {faq.answer}
                        </dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </ContentPlacer>
      </PageDefault>
    </>
  );
}
